import { ReportEventType, type ReportEvent } from '@/types/report';
import type { IdentityToken } from '@/types/identity';
import { getEntityKindForClass } from '@/utils/detection-classes';

function matchesToken(event: ReportEvent, token: IdentityToken): boolean {
    if (token === 'undefined:person' || token === 'undefined:vehicle') {
        const [, kind] = token.split(':');
        return (
            event.identityId === null &&
            getEntityKindForClass(event.classId) === kind
        );
    }
    const [, identityId] = token.split(':');
    return event.identityId === identityId;
}

export function filterReportEventsByIdentity(
    events: ReportEvent[],
    selectedTokens: Set<IdentityToken>,
): ReportEvent[] {
    if (selectedTokens.size === 0) {
        return events;
    }
    const tokens = Array.from(selectedTokens);
    return events.filter(
        (event) =>
            event.eventType === ReportEventType.CUSTOM ||
            tokens.some((token) => matchesToken(event, token)),
    );
}
